import { useRef } from 'react';
import classNames from 'classnames';

import { icon_arrow_right } from '@gn-audio/icons';

import { JabraFocusItem } from '../JabraFocus';
import { JabraIcon } from '../JabraIcon/JabraIcon';
import { DISPLAY_VERSIONS } from '../MegaMenu';

export type RegionItemProps = {
  id: string;
  region: string;
  onSelect: () => void;
  active: boolean;
  focused: boolean;
};

type DesktopRegionItemProps = {
  ariaControls: string;
} & RegionItemProps;

export const DesktopRegionItem = ({
  region,
  onSelect,
  active,
  ariaControls,
  id,
}: DesktopRegionItemProps) => {
  const ref = useRef<HTMLButtonElement>(null);

  return (
    <li
      className="block border-b border-b-gray-100"
      id={id}
      aria-selected={active}
      aria-controls={ariaControls}
      role="tab"
      onClick={onSelect}
      onMouseEnter={onSelect}
    >
      <JabraFocusItem asChild onFocus={onSelect}>
        <button
          className={classNames(
            'group -mb-[1px] flex w-[214px] items-center justify-between pb-[9px] pt-2',
            `yellow-underline ${active && 'active'}`,
            DISPLAY_VERSIONS.DESKTOP
          )}
          ref={ref}
        >
          <span className="ml-1 font-bold leading-5">{region}</span>
          <JabraIcon
            className={classNames(
              `icon yellow mx-1 h-5 transition-all duration-300 ease-linear group-hover:translate-x-0 group-hover:opacity-100`,
              active
                ? 'translate-x-0 opacity-100 group-focus:opacity-100 group-focus-visible:translate-x-0'
                : '-translate-x-full opacity-0'
            )}
            Icon={icon_arrow_right}
          />
        </button>
      </JabraFocusItem>
    </li>
  );
};
